import _ from 'lodash';
import { Message } from 'element-ui';

const defaultOptions = {
  showClose: true,
};

export const showMessage = (message, options = {}) => {
  const parsedMessage = (_.isArray(message)) ? message.join(', ') : message;

  Message({
    ...defaultOptions,
    message: parsedMessage,
    ...options,
  });
};

export const showSuccessMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'success',
    ...options,
  });
};

export const showErrorMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'error',
    ...options,
  });
};

export const showWarningMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'warning',
    ...options,
  });
};



// WEBPACK FOOTER //
// ./src/ui/message.js